import { toast } from "react-toastify"
import { getBrandCampaignIdsData, getClientCampaignIdsData, getCreativeData, getDynamicTextData, getFigmaObj, getFontListData, getMarketCampaignIdsData, getVersion, postClick, postClickDetail, postHeatmap, postImpression, postImpressionDetail } from "../../helpers/backend_helper"
import { setAnalyticsCampaigns, setClick, setImpression, getImpressionByDevice, setInfoContLoader, getLocation, getClickByDevice, getStatistics, getCreatives, setCreativesData, setChildTableData, setImpressionByDeviceData, setClickByDeviceData, setLocationData, setStatisticsChartData, setActiveDynamicText, updateCreativeFigmaAfterDynamicText, setCreatives, setConnectedFeed, setHeatmapFirstData, setHeatmapData, setHeatmapTotalPage } from "./reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { calculatePreviousStartDate, reduceSocialCampaigns } from "./helper";
import { push, replace } from "redux-first-history";
import { setBrandPath, setMarketPath } from "../auth/menu/thunk";
import { setCampaignPath } from "../auth/menu/reducer";
import { setVersions } from "./reducer";
import { convertHeatmapObjToArray } from "./helper";
import { getPointsFromHeatmap } from "./helper";
import { getFontNamesFromDynamicText } from "./helper";
import { createLinkForDynamicTextFont } from "./helper";
import config from "../../config";
import { getPreviewWithoutAuth } from "../feeds/thunk";
const previewUrl = config[config.status].previewUrl;


export const getClientCampaignIds = createAsyncThunk('analytics/getClientCampaignIdsData', async (data, { dispatch, getState }) => {
  try {
    const company = getState().MenuData.client;
    const { selectedClientId } = getState().Analytics;
    if (selectedClientId !== '1') {
      let res = await getClientCampaignIdsData({ clientId: selectedClientId });
      if (res.status === 'ok') {
        const campaigns = reduceSocialCampaigns(res.message);
        dispatch(setAnalyticsCampaigns(campaigns));
        return campaigns;
      } else {
        throw res;
      }
    } else {
      const campaignIds = []
      let i = 0;
      do {
        let res = await getClientCampaignIdsData({ clientId: company.clients[i]._id });
        if (res.status === 'ok') {
          campaignIds.push(...res.message);
        }
        i++;
      } while (i < company.clients.length);
      return campaignIds
    }

  } catch (error) {
    // console.log(error);
  }
})

export const getBrandCampaignIds = createAsyncThunk('analytics/getBrandCampaignIdsData', async (data, { dispatch, getState }) => {
  try {
    const { selectedBrandId } = getState().Analytics;
    const res = await getBrandCampaignIdsData({ brandId: selectedBrandId });
    if (res.status === 'ok') {
      const campaigns = reduceSocialCampaigns(res.message);
      dispatch(setAnalyticsCampaigns(campaigns));
      return campaigns;
    } else {
      throw res;
    }
  } catch (error) {
  }
})

export const getMarketCampaignIds = createAsyncThunk('analytics/getMarketCampaignIdsData', async (params, { dispatch, getState }) => {
  try {
    const { selectedMarketId } = getState().Analytics;
    const res = await getMarketCampaignIdsData({ marketId: selectedMarketId });
    if (res.status === 'ok') {
      const campaigns = reduceSocialCampaigns(res.message);
      dispatch(setAnalyticsCampaigns(campaigns));
      return campaigns;
    } else {
      throw res;
    }
  } catch (error) {
  }
})

export const getTotalImpression = createAsyncThunk('analytics/getImpressionAll', async (params, { dispatch, getState }) => {
  try {
    const { analyticsCampaigns, startDate, endDate } = getState().Analytics;
    const res = await postImpression(params);
    if (res.status === 'ok') {
      if (res.data.length > 0) {
        let resArray = [...res.data];
        if (res.hasOwnProperty('datafv')) {
          resArray = [...res.data, res.datafv];
        }
        let totalImpression = resArray.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
        // const prevStartDate = calculatePreviousStartDate(startDate, endDate);
        // const prevRes = await postImpression({
        //   action: action,
        //   startTime: prevStartDate,
        //   endTime: startDate,
        // })
        let prevImpression;
        // if (prevRes.status === 'ok') {
        //   prevImpression = prevRes.data.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
        // } else {
        prevImpression = 0
        // }
        return { current: totalImpression, prev: prevImpression }
        return { current: 5430001, prev: 0 }
      } else {
        return { current: 0, prev: 0 }
      }
    } else {
      throw res
    }
  } catch (error) {
    // console.log(error);
    // toast.error(error?.message, { autoClose: 3000 })
    return { current: null, prev: null };
  }
});

export const getCreativeImpression = createAsyncThunk('analytics/getCreativeImpression', async (params, { dispatch, getState }) => {
  try {
    const { analyticsCampaigns, startTime, endTime } = getState().Analytics;
    const res = await postImpression(params);
    if (res.status === 'ok') {
      let resArray = [...res.data];
      if (res.hasOwnProperty('datafv')) {
        resArray = [...res.data, ...res.datafv];
      }
      return resArray;
    } else {
      throw res;
    }
  } catch (error) {
  }
});

export const getTotalClick = createAsyncThunk('analytics/getClickAll', async (params, { dispatch, getState }) => {
  try {
    const { analyticsCampaigns, startDate, endDate } = getState().Analytics;
    const res = await postClick(params);
    if (res.status === 'ok') {
      if (res.data.length > 0) {
        const totalClick = res.data.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
        // const prevStartDate = calculatePreviousStartDate(startDate, endDate);
        // const prevRes = await postClick({
        //   action: action,
        //   startTime: prevStartDate,
        //   endTime: startDate,
        //   campagnIds: ['5b486d4057d0e42a3ca9c106']
        // })
        let prevClick;
        // if (prevRes.status === 'ok') {
        //   prevClick = prevRes.data.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
        // } else {
        prevClick = 0;
        // }
        return { current: totalClick, prev: prevClick };
        return { current: 178368, prev: 0 };
      } else {
        return { current: 0, prev: 0 }
      }

    } else {
      throw res
    }
  } catch (error) {
    // toast.error(error?.message, { autoClose: 3000 })
    return { current: 0, prev: 0 };
  }
})

export const getCreativeClick = createAsyncThunk('analytics/getCreativeClick', async (params, { dispatch, getState }) => {
  try {
    const { analyticsCampaigns, startTime, endTime } = getState().Analytics;
    const res = await postClick(params);
    if (res.status === 'ok') {
      return res.data;
    } else {
      throw res;
    }
  } catch (error) {
  }
});

export const createAnalytics = createAsyncThunk('analytics/createAnalyticsData', async (pushBool = true, { dispatch, getState }) => {
  try {
    const { client, clientPath, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { analyticsCampaigns, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    let path = '';
    let idPath = '';
    let states = null;
    dispatch(setChildTableData([]));
    dispatch(setImpressionByDeviceData(null));
    dispatch(setClickByDeviceData(null));
    dispatch(setLocationData(null));
    dispatch(setStatisticsChartData(null));
    dispatch(setCreativesData(null));
    if (selectedClientId) {
      if (selectedClientId !== '1') {
        const foundClient = client.clients.find(item => item._id === selectedClientId);
        path += "/" + foundClient.clientName.toLowerCase().replaceAll(/\s+/g, "-");
        if (selectedBrandId && selectedBrandId !== '1') {
          const foundBrand = foundClient.brands.find(item => item._id === selectedBrandId);
          path += '/' + foundBrand.name.toLowerCase().replaceAll(/\s+/g, "-");
          if (selectedMarketId && selectedMarketId !== '1') {
            const foundMarket = foundBrand.markets.find(item => item._id === selectedMarketId);
            path += '/' + foundMarket.name.toLowerCase().replaceAll(/\s+/g, "-");
            if (selectedCampaignId && selectedCampaignId !== '1') {
              idPath += '/' + selectedCampaignId;
              states = await dispatch(createCreativeAnalytics());
            } else {
              states = await dispatch(createMarketAnalytics());
            }
          } else {
            // get brand
            // campaigns = await dispatch(getBrandCampaignIds()).payload;
            states = await dispatch(createBrandAnalytics());
          }
        } else {
          states = await dispatch(createClientAnalytics());
        }
      } else {
        path += `/all`;
        states = await dispatch(createAllClientAnalytics());
      }
     
      if (pushBool) {
        if (path === '/all') {
          dispatch(replace(window.location.href, states));
        } else {
          dispatch(push(`${path}/analytics${idPath}`, states));
        }
      }
    } else {
      // error
      throw { message: 'Something went wrong' }
    }
  } catch (error) {
    // console.log(error);
    toast.error(error?.message, { autoClose: 3000 });
  }
});

export const createAllClientAnalytics = () => async (dispatch, getState) => {
  try {
    const { client, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { startDate, endDate, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    if (client.clients.length > 0) {
      const campaigns = await dispatch(getClientCampaignIds());
      const totalImpression = await dispatch(getTotalImpression({
        action: 'all',
        startTime: startDate,
        endTime: endDate,
        campaignIds: campaigns.payload.map(item => item._id)
        // campaignIds: ['5b486d4057d0e42a3ca9c106']
      }));
      const totalClick = await dispatch(getTotalClick({
        action: 'all',
        startTime: startDate,
        endTime: endDate,
        campaignIds: campaigns.payload.map(item => item._id)
        // campaignIds: ['5b486d4057d0e42a3ca9c106']
      }));
      const childTable = await dispatch(createChildTable({
        foundChilds: client.clients,
        title: 'All Clients',
        getCampaignIds: getClientCampaignIdsData,
        getCampaignIdQuery: 'clientId',
        childNameKey: 'clientName'
      }));
      dispatch(setCreativesData(null));
      return {
        selectedClientId: selectedClientId,
        selectedBrandId: selectedBrandId,
        selectedMarketId: selectedMarketId,
        selectedCampaignId: selectedCampaignId,
        campaignsState: campaigns.payload,
        totalImpression: totalImpression.payload,
        totalClick: totalClick.payload,
        childTableState: childTable.payload,
        impressionByDeviceState: null,
        clickByDeviceState: null,
        locationState: null,
        statisticsState: null,
        creativeDataState: null,
        versionsState: null,
      }
    }

  } catch (error) {
  }
}

export const createClientAnalytics = () => async (dispatch, getState) => {
  try {
    const { client, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { startDate, endDate, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    const campaigns = await dispatch(getClientCampaignIds());
    const totalImpression = await dispatch(getTotalImpression({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const totalClick = await dispatch(getTotalClick({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const foundClient = client.clients.find(item => item._id === selectedClientId);
    const childTable = await dispatch(createChildTable({
      foundChilds: foundClient.brands,
      title: foundClient.clientName,
      getCampaignIds: getBrandCampaignIdsData,
      getCampaignIdQuery: 'brandId',
      childNameKey: 'name'
    }));
    dispatch(setCreativesData(null));
    return {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: campaigns.payload,
      totalImpression: totalImpression.payload,
      totalClick: totalClick.payload,
      childTableState: childTable.payload,
      impressionByDeviceState: null,
      clickByDeviceState: null,
      locationState: null,
      statisticsState: null,
      creativeDataState: null,
      versionsState: null,
    }
  } catch (error) {
    return false;
  }
};

export const createBrandAnalytics = () => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { startDate, endDate, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    const campaigns = await dispatch(getBrandCampaignIds());
    const totalImpression = await dispatch(getTotalImpression({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const totalClick = await dispatch(getTotalClick({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const foundClient = client.clients.find(item => item._id === selectedClientId);
    const foundBrand = foundClient.brands.find(item => item._id === selectedBrandId);
    const childTable = await dispatch(createChildTable({
      foundChilds: foundBrand.markets,
      title: foundBrand.name,
      getCampaignIds: getMarketCampaignIdsData,
      getCampaignIdQuery: 'marketId',
      childNameKey: 'name'
    }));
    dispatch(setCreativesData(null));
    return {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: campaigns.payload,
      totalImpression: totalImpression.payload,
      totalClick: totalClick.payload,
      childTableState: childTable.payload,
      impressionByDeviceState: null,
      clickByDeviceState: null,
      locationState: null,
      statisticsState: null,
      creativeDataState: null,
      versionsState: null,
    }
  } catch (error) {
    return false;
  }
};

export const createMarketAnalytics = () => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { startDate, endDate, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    const campaigns = await dispatch(getMarketCampaignIds());
    const totalImpression = await dispatch(getTotalImpression({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const totalClick = await dispatch(getTotalClick({
      action: 'all',
      startTime: startDate,
      endTime: endDate,
      campaignIds: campaigns.payload.map(item => item._id)
      // campaignIds: ['5b486d4057d0e42a3ca9c106']
    }));
    const foundClient = client.clients.find(item => item._id === selectedClientId);
    const foundBrand = foundClient.brands.find(item => item._id === selectedBrandId);
    const foundMarket = foundBrand.markets.find(item => item._id === selectedMarketId);
    const childTable = await dispatch(createChildTable({
      foundChilds: campaigns.payload,
      title: foundMarket.name,
      getCampaignIds: getMarketCampaignIds,
      getCampaignIdQuery: 'campaign',
      childNameKey: 'name'
    }));

    dispatch(setCreativesData(null));
    return {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: campaigns.payload,
      totalImpression: totalImpression.payload,
      totalClick: totalClick.payload,
      childTableState: childTable.payload,
      impressionByDeviceState: null,
      clickByDeviceState: null,
      locationState: null,
      statisticsState: null,
      creativeDataState: null,
      versionsState: null,
    }
  } catch (error) {
    // console.log(error);
    return false;
  }
};

export const createCreativeAnalytics = () => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, marketPath, campaignPath } = getState().MenuData;
    const { startDate, endDate, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = getState().Analytics;
    const campaigns = await dispatch(getMarketCampaignIds());
    let i = 0;
    const impression = [];
    const click = [];
    do {
      const campaignId = campaigns.payload[i]._id;
      const impressionRes = await postImpression({
        action: 'campaign',
        startTime: startDate,
        endTime: endDate,
        // campaignIds: campaigns.payload.map(item => item._id)
        campaignId: campaignId
      });
      const clickRes = await postClick({
        action: 'campaign',
        startTime: startDate,
        endTime: endDate,
        // campaignIds: campaigns.payload.map(item => item._id)
        campaignId: campaignId
      });
      if (impressionRes.status === 'ok') {
        impression.push(...impressionRes.data);
        if (impressionRes.hasOwnProperty('datafv')) {
          impression.push(...impressionRes.datafv);
        }
      }
      if (clickRes.status === 'ok') {
        click.push(...clickRes.data);
      }
      i++;
    } while (i < campaigns.payload.length);
    let childTable = false;
    const versions = await getVersion({ id: selectedCampaignId });
    const foundCampaign = campaigns.payload.find(item => item._id === selectedCampaignId);
    if (versions.status === "ok" && foundCampaign) {
      dispatch(setImpression(impression.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0)));
      dispatch(setClick(click.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0)));
      dispatch(setInfoContLoader(false));
      childTable = await dispatch(createChildTable({
        foundChilds: versions.data,
        title: 'Versions',
        getCampaignIds: getMarketCampaignIds,
        getCampaignIdQuery: 'creative',
        childNameKey: 'name',
        creativeClick: click,
        creativeImpression: impression
      }));
    }
    const creativeTable = await dispatch(createCreativeTable({ impression: impression, click: click, version: versions.data }));
    return {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: campaigns.payload,
      totalImpression: { current: impression.reduce((prevValue, currentVal) => prevValue + currentVal?.total, 0), prev: 0 },
      totalClick: { current: click.reduce((prevValue, currentVal) => prevValue + currentVal?.total, 0), prev: 0 },
      childTableState: childTable.payload,
      impressionByDeviceState: null,
      clickByDeviceState: null,
      locationState: null,
      statisticsState: null,
      creativeDataState: creativeTable.payload,
      versionsState: versions.data,
    }
  } catch (error) {
    // console.log(error);
    return false;
  }
}

export const createChildTable = createAsyncThunk('analytics/createChildTable', async (
  { foundChilds, title, getCampaignIds, getCampaignIdQuery, childNameKey, creativeClick, creativeImpression },
  { dispatch, getState }) => {
  try {
    const { startDate, endDate } = getState().Analytics;
    const tableArr = [];
    if (foundChilds && foundChilds.length > 0) {
      let i = 0;
      do {
        const child = foundChilds[i];
        let impression;
        let click;
        let campaignIds;
        let impressionRes;
        let clickRes;
        if (getCampaignIdQuery === 'campaign') {
          campaignIds = {};
          campaignIds.status = 'ok';
          campaignIds.data = child._id;
          impressionRes = await postImpression({
            action: 'campaign',
            startTime: startDate,
            endTime: endDate,
            campaignId: campaignIds.data
          })
          clickRes = await postClick({
            action: 'campaign',
            startTime: startDate,
            endTime: endDate,
            campaignId: campaignIds.data
          });
        } else if (getCampaignIdQuery === 'creative') {
          campaignIds = {};
          campaignIds.status = 'ok';
          campaignIds.data = child._id;
          impressionRes = {};
          impressionRes.status = 'ok';          
          impressionRes.data = creativeImpression.filter(item => item._id.versionId === child._id);
          clickRes = {};
          clickRes.status = 'ok';
          clickRes.data = creativeClick.filter(item => item._id.versionId === child._id);
        } else {
          const campaignRes = await getCampaignIds({ [getCampaignIdQuery]: child._id });
          campaignIds = campaignRes;
          if (campaignIds.status === 'ok') {
            campaignIds.data = campaignIds.message.map(item => item._id);
          } else {
            campaignIds.data = [];
          }
          if (campaignIds) {
            impressionRes = await postImpression({
              action: 'all',
              startTime: startDate,
              endTime: endDate,
              campaignIds: campaignIds.data
            });
            clickRes = await postClick({
              action: 'all',
              startTime: startDate,
              endTime: endDate,
              campaignIds: campaignIds.data
            });
          }
        }
        if (campaignIds.status === 'ok') {
          if (impressionRes.status === 'ok') {
            let impresssionArray = [...impressionRes.data];
            if (impressionRes.hasOwnProperty('datafv')) {
              impresssionArray = [...impressionRes.data, ...impressionRes.datafv];
            }
            impression = impresssionArray.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
          } else {
            impression = 0;
          }
          if (clickRes.status === 'ok') {
            click = clickRes.data.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
          } else {
            click = 0;
          }
        } else {
          impression = 0;
          click = 0;
        }
        const ctr = (click / impression) * 100;
        tableArr.push({
          id: child._id,
          name: child[childNameKey],
          impression: impression,
          click: click,
          ctr: (ctr ? ctr : 0)
        })
        i++;
      } while (i < foundChilds.length);
    }
    return { data: tableArr, title: title };
  } catch (error) {
    return null;
  }
});

export const createImpressionByDeviceTable = (params) => async (dispatch, getState) => {
  try {
    const { startDate, endDate } = getState().Analytics;
    const impressionDetailRes = await postImpressionDetail(params);
    if (impressionDetailRes.status === 'ok') {
      let dataObj = {};
      let impressionDetailArr = [...impressionDetailRes.data];
      if (impressionDetailRes.hasOwnProperty('datafv')) {
        impressionDetailArr = [...impressionDetailRes.data, ...impressionDetailRes.datafv]
      }
      impressionDetailArr.forEach(item => {
        if (dataObj[item._id.device]) {
          dataObj[item._id.device] += item.total;
        } else {
          dataObj[item._id.device] = item.total;
        }
      });
      return dataObj;
      // return { ios: 10000, android: 15000, tv: 1000 };
    } else {
      throw impressionDetailRes;
    }
  } catch (error) {
    return null;
  }
}

export const createClickByDeviceTable = (params) => async (dispatch, getState) => {
  try {
    const { startDate, endDate } = getState().Analytics;
    const clickDetailRes = await postClickDetail(params);
    if (clickDetailRes.status === 'ok') {
      let dataObj = {};
      clickDetailRes.data.forEach(item => {
        if (dataObj[item._id.device]) {
          dataObj[item._id.device] += item.total;
        } else {
          dataObj[item._id.device] = item.total;
        }
      });
      return dataObj;
      return { ios: 10000, android: 8000, tv: 0 };
    } else {
      throw clickDetailRes;
    }
  } catch (error) {
    return null;
  }
}

export const createLocationTable = (params) => async (dispatch, getState) => {
  try {
    const impressionRes = await postImpressionDetail(params);
    if (impressionRes.status === 'ok') {
      let dataObj = {};
      let impresssionArr = [...impressionRes.data];
      if (impressionRes.hasOwnProperty('datafv')) {
        impresssionArr = [...impressionRes.data, ...impressionRes.datafv];
      }
      impresssionArr.forEach(item => {
        if (dataObj[item._id.country]) {
          dataObj[item._id.country] += item.total;
        } else {
          dataObj[item._id.country] = item.total;
        }
      });
      return dataObj;
    } else {
      throw impressionRes;
    }
    return {
      "US": 300000,
      "RU": 15000
    }
  } catch (error) {
    return null;
  }
}

export const createStatisticChart = (campaignIds) => async (dispatch, getState) => {
  try {
    const { startDate, endDate } = getState().Analytics;
    let chartObj = {};
    let i = 0;
    do {
      const impressionRes = await postImpression({
        action: 'campaign',
        campaignId: campaignIds[i],
        startTime: startDate,
        endTime: endDate
      });
      if (impressionRes.status === 'ok') {
        let impressionArr = [...impressionRes.data];
        if (impressionRes.hasOwnProperty('datafv')) {
          impressionArr = [...impressionRes.data, ...impressionRes.datafv];
        }
        impressionArr.forEach(item => {
          if (chartObj[item._id.year + "T" + item._id.hour]) {
            chartObj[item._id.year + "T" + item._id.hour].impression += item.total;
          } else {
            chartObj[item._id.year + "T" + item._id.hour] = {};
            chartObj[item._id.year + "T" + item._id.hour].impression = item.total;
            chartObj[item._id.year + "T" + item._id.hour].click = 0;
          }
        })
      }
      const clickRes = await postClick({
        action: 'campaign',
        campaignId: campaignIds[i],
        startTime: startDate,
        endTime: endDate
      });
      if (clickRes.status === 'ok') {
        clickRes.data.forEach(item => {
          if (chartObj[item._id.year + 'T' + item._id.hour]) {
            chartObj[item._id.year + 'T' + item._id.hour].click += item.total;
          } else {
            chartObj[item._id.year + 'T' + item._id.hour] = {};
            chartObj[item._id.year + 'T' + item._id.hour].click = item.total;
            if (!chartObj[item._id.year + 'T' + item._id.hour].hasOwnProperty('impression')) {
              chartObj[item._id.year + 'T' + item._id.hour].impression = 0;
            }
          }
        })
      }
      i++;
    } while (i < campaignIds.length);
    return chartObj
    return {
      "2024-9-10T09:15": {
        "impression": 56709,
        "click": 1231
      },
      "2024-9-11T09:15": {
        "impression": 31652,
        "click": 0
      },
      "2024-9-11T09:00": {
        "impression": 15272,
        "click": 41892
      },
      "2024-9-11T09:30": {
        "impression": 13078,
        "click": 0
      },
      "2024-9-11T08:30": {
        "click": 60000,
        "impression": 0
      },
      "2024-9-11T02:00": {
        "click": 32656,
        "impression": 0
      },
      "2024-9-11T01:30": {
        "click": 32124,
        "impression": 0
      },
      "2024-9-11T02:30": {
        "click": 30000,
        "impression": 0
      },
      "2024-9-11T08:45": {
        "click": 22700,
        "impression": 0
      },
      "2024-9-11T02:15": {
        "click": 21344,
        "impression": 0
      }
    };
    // 
  } catch (error) {
    // console.log(error);
    return null;
  }
}

export const createCreativeTable = createAsyncThunk('analytics/getCreativeTableData', async ({ impression, click }, { dispatch, getState }) => {
  try {
    const { selectedCampaignId, startDate, endDate } = getState().Analytics;
    const tableData = [];
    const versions = await getVersion({ id: selectedCampaignId });
    if (versions.status === 'ok') {
      if (versions.data.length > 0) {
        dispatch(setVersions(versions.data));
        let obj = {};
        let i = 0;
        do {
          const version = versions.data[i];
          const creatives = await getCreativeData({ versionId: version._id });
          if (creatives.status === 'ok') {
            if (creatives.data.length > 0) {
              let k = 0;
              do {
                const creative = creatives.data[k];
                const campaignId = selectedCampaignId;
                const publishId = (impression[0]?._id.publishId || "");
                const creativeId = creative._id;
                const foundClicks = click.filter(item => item._id.creativeId === creative._id);
                const foundImpressions = impression.filter(item => item._id.creativeId === creative._id);
                const totalClick = foundClicks.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
                const totalImpression = foundImpressions.reduce((prevValue, currentVal) => prevValue + currentVal.total, 0);
                const ctr = (totalClick / totalImpression) * 100;
                tableData.push({
                  size: creative.size,
                  versionName: version.name,
                  versionId: version._id,
                  impression: totalImpression,
                  click: totalClick,
                  ctr: (ctr ? ctr : '0%'),
                  campaignId: campaignId,
                  publishId: publishId,
                  creativeId: creativeId,
                  creativeData: { ...creative }
                });
                k++;
              } while (k < creatives.data.length);
            }
          }
          i++;
        } while (i < versions.data.length);
      }
      return tableData;
    } else {
      throw versions;
    }
  } catch (error) {
    // console.log(error);
  }
});

export const getImpressionTable = createAsyncThunk('analytics/getImpressionByDeviceData', async (campaignIds, { dispatch, getState }) => {
  try {
    const { client } = getState().MenuData;
    const {
      selectedClientId,
      selectedBrandId,
      selectedMarketId,
      selectedCampaignId,
      startDate,
      endDate,
      analyticsCampaigns,
      impression,
      click,
      childTableData,
      impressionByDeviceData,
      clickByDeviceData,
      locationData,
      creativesData,
      statisticsChartData
    } = getState().Analytics;
    let res;
    if (selectedCampaignId && selectedCampaignId !== '1') {
      // Campaign
      res = await dispatch(createImpressionByDeviceTable({
        action: 'campaign',
        campaignId: selectedCampaignId,
        // campaignId: '5b486d4057d0e42a3ca9c106',
        startTime: startDate,
        endTime: endDate,
        detail: 'device'
      }));
    } else {
      // Market       
      res = await dispatch(createImpressionByDeviceTable({
        action: 'all',
        campaignIds: campaignIds.map(item => item._id),
        // campaignIds: ['5b486d4057d0e42a3ca9c106', '5b486d4057d0e42a3ca9c106'],
        startTime: startDate,
        endTime: endDate,
        detail: 'device'
      }));
    }
    dispatch(push(window.location.href, {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: analyticsCampaigns,
      totalImpression: impression,
      totalClick: click,
      childTableState: childTableData,
      impressionByDeviceState: res,
      clickByDeviceState: clickByDeviceData,
      locationState: locationData,
      statisticsState: statisticsChartData,
      creativeDataState: creativesData
    }));
    return res;
  } catch (error) {
  }
});

export const getClickTable = createAsyncThunk('analytics/getClickByDeviceData', async (campaignIds, { dispatch, getState }) => {
  try {
    const { client } = getState().MenuData;
    const {
      selectedClientId,
      selectedBrandId,
      selectedMarketId,
      selectedCampaignId,
      startDate,
      endDate,
      analyticsCampaigns,
      impression,
      click,
      childTableData,
      impressionByDeviceData,
      clickByDeviceData,
      locationData,
      creativesData,
      statisticsChartData
    } = getState().Analytics;
    let res;
    if (selectedCampaignId && selectedCampaignId !== '1') {
      // Campaign
      res = await dispatch(createClickByDeviceTable({
        action: 'campaign',
        campaignId: selectedCampaignId,
        // campaignId: '5b486d4057d0e42a3ca9c106',
        startTime: startDate,
        endTime: endDate,
        detail: 'device'
      }));
    } else {
      // Market
      res = await dispatch(createClickByDeviceTable({
        action: 'all',
        campaignIds: campaignIds.map(item => item._id),
        // campaignIds: ['5b486d4057d0e42a3ca9c106', '5b486d4057d0e42a3ca9c106'],
        startTime: startDate,
        endTime: endDate,
        detail: 'device'
      }));
    }
    dispatch(push(window.location.href, {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: analyticsCampaigns,
      totalImpression: impression,
      totalClick: click,
      childTableState: childTableData,
      impressionByDeviceState: impressionByDeviceData,
      clickByDeviceState: res,
      locationState: locationData,
      statisticsState: statisticsChartData,
      creativeDataState: creativesData
    }));
    return res;
  } catch (error) {
  }
})

export const getLocationTable = createAsyncThunk('analytics/getLocationImpressionData', async (campaignIds, { dispatch, getState }) => {
  try {
    const { client } = getState().MenuData;
    const {
      selectedClientId,
      selectedBrandId,
      selectedMarketId,
      selectedCampaignId,
      startDate,
      endDate,
      analyticsCampaigns,
      impression,
      click,
      childTableData,
      impressionByDeviceData,
      clickByDeviceData,
      locationData,
      creativesData,
      statisticsChartData
    } = getState().Analytics;
    let res;
    if (selectedCampaignId && selectedCampaignId !== '1') {
      // Campaign
      res = await dispatch(createLocationTable({
        action: 'campaign',
        // campaignIds: campaignIds,
        campaignId: selectedCampaignId,
        startTime: startDate,
        endTime: endDate,
        detail: 'location'
      }));
    } else {
      // Market            
      res = await dispatch(createLocationTable({
        action: 'all',
        campaignIds: campaignIds.map(item => item._id),
        // campaignIds: ['5b486d4057d0e42a3ca9c106', '5b486d4057d0e42a3ca9c106'],
        startTime: startDate,
        endTime: endDate,
        detail: 'location'
      }));
    }
    dispatch(push(window.location.href, {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: analyticsCampaigns,
      totalImpression: impression,
      totalClick: click,
      childTableState: childTableData,
      impressionByDeviceState: impressionByDeviceData,
      clickByDeviceState: clickByDeviceData,
      locationState: res,
      statisticsState: statisticsChartData,
      creativeDataState: creativesData
    }));
    return res;
  } catch (error) {
    return null;
  }
});

export const getStatisticChart = createAsyncThunk('analytics/getStatisticChartData', async (campaignIds, { dispatch, getState }) => {
  try {
    const { client } = getState().MenuData;
    const {
      selectedClientId,
      selectedBrandId,
      selectedMarketId,
      selectedCampaignId,
      analyticsCampaigns,
      impression,
      click,
      childTableData,
      impressionByDeviceData,
      clickByDeviceData,
      locationData,
      creativesData,
      statisticsChartData,
    } = getState().Analytics;
    let res;
    if (selectedCampaignId && selectedCampaignId !== '1') {
      res = await dispatch(createStatisticChart([selectedCampaignId]));
    } else {
      res = await dispatch(createStatisticChart(campaignIds.map(item => item._id)));
    }
    dispatch(push(window.location.href, {
      selectedClientId: selectedClientId,
      selectedBrandId: selectedBrandId,
      selectedMarketId: selectedMarketId,
      selectedCampaignId: selectedCampaignId,
      campaignsState: analyticsCampaigns,
      totalImpression: impression,
      totalClick: click,
      childTableState: childTableData,
      impressionByDeviceState: impressionByDeviceData,
      clickByDeviceState: clickByDeviceData,
      locationState: locationData,
      statisticsState: res,
      creativeDataState: creativesData
    }));
    return res
  } catch (error) {
    // console.log(error);
  }
});

export const getCreativePreview = createAsyncThunk('creative/getCreativePreviewData', async (creativeRow, { dispatch, getState }) => {
  try {
    const { analyticsCampaigns, selectedCampaignId } = getState().Analytics;
    const foundCampaign = analyticsCampaigns.find(item => item._id === selectedCampaignId);
    let creative = null;
    if (foundCampaign) {
      if (foundCampaign.bannerType === 'html' || foundCampaign.adType === 'social') {
        creative = await dispatch(getHtmlPreview(creativeRow));
      } else if (foundCampaign.bannerType === 'image') {
        creative = await dispatch(getImagePreview(creativeRow));
      }
    }
    return { ...creative.payload, publishId: creativeRow.publishId, creativeId: creativeRow.creativeId };
  } catch (error) {
    // console.log(error);
  }
})

export const getHtmlPreview = createAsyncThunk('creative/getHtmlPreview', async (creativeRow, { dispatch, getState }) => {
  try {
    const { versions } = getState().Analytics;
    const foundVersion = versions.find(item => item._id === creativeRow.versionId);
    const creativeArr = [];
    if (foundVersion) {
      if (foundVersion.hasOwnProperty('feeds') && Array.isArray(foundVersion?.feeds)) {
        // const feedRes = await dispatch(getFeed(foundVersion.feeds[0]));
        const feedRes = await dispatch(getPreviewWithoutAuth(foundVersion.feeds[0]));
        dispatch(setConnectedFeed(feedRes));
      }
      // dispatch(setConnectedFeed(undefined));
      const dynamicTextRes = await dispatch(getDynamicText({ versionId: foundVersion._id }));
      // const figmaObj = await getFigmaObj(`${creativeRow.creativeData.figma}?timestamp=${new Date().getTime()}`);
      dispatch(setCreatives([{ ...creativeRow.creativeData }]));
      // await dispatch(setCreativeFigmaBeforePreview());
      // const fontNames = getFontNamesFromDynamicText(dynamicTextRes.payload);
      // const fontRes = await dispatch(getFontList(fontNames));
      // const fontStr = await createLinkForDynamicTextFont(fontRes.payload);
      // const updatedCreatives = await dispatch(setHtmlCreativesPreview(fontStr));
      creativeArr.push(creativeRow.creativeData);
    }
    return creativeArr[0];
  } catch (error) {
    // console.log(error);
  }
});

export const getImagePreview = createAsyncThunk('creative/getImagePreview', async (creativeRow, { dispatch, getState }) => {
  try {
    return creativeRow.creativeData;
  } catch (error) {
  }
})

export const getCreativeFigmaObj = (creatives) => async () => {
  try {
    const updatedCreatives = [];
    let i = 0;
    do {
      const creative = creatives[i];
      if (creative && creative.hasOwnProperty('figma')) {
        let figmaObj = await getFigmaObj(creative.figma);
        const creativeObj = {
          ...creative,
          figmaObject: figmaObj
        }
        updatedCreatives.push(creativeObj)
      } else {
        updatedCreatives.push(creative);
      };
      i++;
    } while (i < creatives.length);
    return updatedCreatives;
  } catch (error) {
  }
}

export const setCreativeFigmaBeforePreview = () => async (dispatch, getState) => {
  try {
    return new Promise((resolve, reject) => {
      const creatives = getState().Analytics.creatives;
      const { dynamicText, activeDynamicText } = getState().Analytics;
      if (dynamicText.length === 1) {
        dispatch(setActiveDynamicText(dynamicText[0]));
        const creativeIds = creatives.filter(item => item.versionId === dynamicText[0].versionId);
        dispatch(updateCreativeFigmaAfterDynamicText({
          creativeIds: creativeIds.map(item => item._id),
          activeDynamicText: dynamicText[0]
        }));
      } else if (dynamicText.length > 1) {
        const creativeDynamicTexts = dynamicText.slice(0, dynamicText.length);
        let i = 0;
        do {
          dispatch(setActiveDynamicText(creativeDynamicTexts[i]));
          let creativeIds = [];
          if (creativeDynamicTexts[i].isCreative === false) {
            creativeIds = creatives.filter(item => {
              if (item.versionId === creativeDynamicTexts[i].versionId) {
                return item;
              }
            });
          } else if (creativeDynamicTexts[i].isCreative === true) {
            creativeIds = creatives.filter(item => {
              if (item._id === creativeDynamicTexts[i].creativeId) {
                return item;
              }
            });
          }
          if (creativeIds.length > 0) {
            dispatch(updateCreativeFigmaAfterDynamicText({
              creativeIds: creativeIds.map(item => item._id),
              activeDynamicText: creativeDynamicTexts[i]
            }));
          }
          i++;
        } while (i < creativeDynamicTexts.length);
        dispatch(setActiveDynamicText(dynamicText[0]));
      }
      resolve(true);
    })
  } catch (error) {
  }
};

export const getFontList = createAsyncThunk("dynamictext/getFontList", async (fontNames, { dispatch, getState }) => {
  try {
    const fonts = [];
    if (fontNames.length > 0) {
      let i = 0;
      do {
        const res = await getFontListData({
          family: fontNames[i]
        });
        if (res.status === 'ok') {
          fonts.push(res.data[0]);
        }
        i++;
      } while (i < fontNames.length);
    }
    return fonts;
  } catch (error) {
  }
});

export const setHtmlCreativesPreview = (fonts) => async (dispatch, getState) => {
  try {
    const { creatives } = getState().Analytics;
    const updatedCreatives = [];
    let i = 0;
    do {
      const creative = creatives[i];
      const previewRes = await dispatch(createPreview(creative, fonts));
      updatedCreatives.push({
        ...creative,
        preview: previewRes.preview
      });
      i++;
    } while (i < creatives.length);
    return updatedCreatives;
  } catch (error) {
  }
};

export const createPreview = (creative, fonts) => async (dispatch, getState) => {
  try {
    return new Promise(async (resolve, reject) => {
      const [width, height] = creative.size.split('x').map(i => i);
      const iframe = document.createElement("iframe");
      iframe.width = `${width}px`;
      iframe.height = `${height}px`;
      iframe.src = previewUrl;
      iframe.style.pointerEvents = 'none';
      iframe.style.userSelect = 'none';
      iframe.style.display = 'none';
      // iframe.src = 'http://127.0.0.1:5000/preview.html';
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.postMessage({
          action: "adc-get-preview",
          figmaObject: creative.figmaObject,
          fonts: fonts
        }, '*');
        resolve({ preview: iframe });
      };
    });
  } catch (error) {
  }
};

export const createHeatmap = createAsyncThunk('creative/createHeatmapData', async (params, { dispatch, getState }) => {
  try {
    const { startDate, endDate, creativePreview } = getState().Analytics;
    let points = [];
    // console.log(creativePreview);
    const heatmapRes = await postHeatmap({
      action: 'creative',
      campaignId: creativePreview.campaignId,
      versionId: creativePreview.versionId,
      publishId: creativePreview.publishId,
      creativeId: creativePreview.creativeId,
      startTime: startDate,
      endTime: endDate
    });
    if (heatmapRes.status === 'ok') {
      if (heatmapRes?.data && heatmapRes?.data.length > 0) {
        dispatch(setHeatmapTotalPage(heatmapRes.total));
        const firstHeatmapData = getPointsFromHeatmap(heatmapRes.data);
        dispatch(setHeatmapFirstData(firstHeatmapData));
        // dispatch(setHeatmapData(firstHeatmapData));
      } else {
        dispatch(setHeatmapTotalPage(0));
        dispatch(setHeatmapFirstData([]));
        dispatch(setHeatmapData([]));
      }
    } else {
      throw heatmapRes;
    }
  } catch (error) {
    // console.log(error);
  }
});

export const fillHeatmap = (page) => async (dispatch, getState) => {
  try {
    const {creativePreview} = getState().Analytics;
    const pageRes = await postHeatmap({
      action: 'creative',
      campaignId: creativePreview.campaignId,
      versionId: creativePreview.versionId,
      publishId: creativePreview.publishId,
      creativeId: creativePreview.creativeId,
      startTime: startDate,
      endTime: endDate,
      page: page
    });
    if (pageRes.status === 'ok') {
      if (pageRes?.data && pageRes?.data.length > 0) {
        const heatmapPageData = getPointsFromHeatmap(pageRes.data);
        return heatmapPageData
      }
    }
    return [];
  } catch (error) {
    // console.log(error);
  }
}

export const getFeed = createAsyncThunk('feed/getFeedPreviewData', async (id, { dispatch, getState }) => {
  try {
    const res = await getFeedData(id);
    if (res) {
      return res;
    }
  } catch (error) {
    // console.log(error);
  }
});

export const getDynamicText = createAsyncThunk('dynamicText/getDynamicTextData', async ({ versionId, creativeId }, { dispatch, getState }) => {
  try {
    const response = await getDynamicTextData({ versionId: versionId, creativeId: creativeId });
    if (response.status === 'ok') {
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    // console.log(error);
    return [];
  }
});